export default __webpack_public_path__ + "static/media/00.ca1bcf43.jpg";